import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container } from 'semantic-ui-react';
import { IBuilding } from '@relab/alstom-ptw-shared';

import { HeaderComponent } from '../components/HeaderComponent';
import { NavBar } from '../components/NavBar';
import { appState } from '../redux/selectors';
import { RootState } from '../redux/types';
import { buildingsAction } from '../redux/actions';
import { BuildingsListComponent } from '../components/building/BuildingsListComponent';
import { BuildingUpsertModal } from '../components/building/BuildingUpsertModal';

interface BuildingsSceneProps extends Component {
  buildingsAction: typeof buildingsAction;
  buildings: IBuilding[];
}

class PBuildingsScene extends Component<BuildingsSceneProps> {
  componentDidMount() {
    this.props.buildingsAction();
  }

  render() {
    const { buildings } = this.props;

    return (
      <React.Fragment>
        <HeaderComponent />
        <NavBar />
        <Container fluid>
          <Container textAlign={'right'}>
            <BuildingUpsertModal />
          </Container>
          <BuildingsListComponent buildings={buildings} />
        </Container>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  buildings: appState(state).buildings,
});

export const BuildingsScene = connect(mapStateToProps, { buildingsAction })(PBuildingsScene);
